/* eslint-disable newline-after-var */

import { Analytics } from "./";

export function addVideoTracking(video_el, analytics_event_properties, threshold = 0.5, visible_time_threshold = 2000) {
    let visible_play_time = 0;
    let prev_timestamp = 0;

    let playing = false;
    let intersecting = false;

    let click_recorded = false;
    let watch_impression_recorded = false; // View watched at least 2 seconds while 50% of the pixel are on screen
    let view_impression_recorded = false; // 50% of the pixel are on screen

    function videoIntersectionHandler(entries) {
        intersecting = entries[0].isIntersecting;

        if (!view_impression_recorded && intersecting) {
            analytics_event_properties.action = "Video_" + video_el.dataset.action;
            Analytics.view(analytics_event_properties);

            view_impression_recorded = true;
        }
    }

    const observer = new IntersectionObserver(videoIntersectionHandler, {
        threshold: threshold
    });
    observer.observe(video_el);

    video_el.addEventListener("play", function(event) {
        visible_play_time = 0;
        prev_timestamp = event.timeStamp;
        playing = true;

        if (!click_recorded) {
            // TODO(trevor) filter out autoplay if tracking is applied autoplaying ads
            // not implemented now because I don't currently have a use case...
            analytics_event_properties.action = "Video_" + video_el.dataset.action;
            Analytics.click(analytics_event_properties);

            click_recorded = true;
        }
    });

    video_el.addEventListener("timeupdate", function(event) {
        if (playing) {
            const dt = event.timeStamp - prev_timestamp;
            prev_timestamp = event.timeStamp;

            if (intersecting && document.visibilityState === "visible") {
                visible_play_time += dt;
            }

            if (!watch_impression_recorded && (visible_play_time >= visible_time_threshold)) {
                watch_impression_recorded = true;
                analytics_event_properties.action = "Video Watch_" + video_el.dataset.action;
                Analytics.view(analytics_event_properties);
            }
        }
    });

    video_el.addEventListener("pause", function() {
        playing = false; // TODO(trevor) is this the only event that should set playing to false?
    });

    // TODO(trevor) do we need to account for error events?
}

window.addEventListener("load", function() {
    const videos = document.getElementsByTagName("video");
    for (const video of videos) {
        if (video.dataset.action && video.dataset.ioNumber && video.dataset.sellerId && video.dataset.sellerName) {
            addVideoTracking(video, {
                label: video.currentSrc,
                value: video.dataset.ioNumber,
                seller: {
                    id: video.dataset.sellerId,
                    name: video.dataset.sellerName
                }
            });
        }
    }
});